import {TeacherStudentsTable} from './TeacherStudentsTable';

export default TeacherStudentsTable;
